import React from "react";
import { withRouter } from "react-router-dom";
import cookie from 'react-cookies';
import { MyToast } from '../Helpers/Toast';
import Axios from '../../config/axios';

class TFALogin extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            formFields: {
                tfaInput: '',
                trustdevice: false
            },
            showToast: false,
            toastContent: {
                title: '',
                content: ''
            }
        };
    }

    toggleToast = (toastContent) => {
        if (toastContent) {
            this.setState({
                showToast: !this.state.showToast,
                toastContent
            });
        } else {
            this.setState({
                showToast: !this.state.showToast
            });
        }
    }

    handleInputChange = (event) => {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;

        this.setState({ formFields: { ...this.state.formFields, [name]: value } });
    }

    verify2FA = async (event) => {
        event.preventDefault();
        let validCode = false;

        let postdata = {};
        postdata.userid = this.props.userid.toString();
        postdata.password = this.props.password.toString();
        postdata.totpcode = this.state.formFields.tfaInput;

        await Axios.post(`/api/Verify2FA`, postdata
        ).then(response => {
            validCode = response.data;
        }).catch(error => {
            console.log(error);
        });

        if (validCode) {
            const timeInSeconds = 3600;
            const expires = new Date();
            expires.setDate(Date.now() + timeInSeconds * 60 * 60 * 24 * 14);
            if (this.state.formFields.trustdevice === true) {
                cookie.save('bypass2FA' + this.props.userid, true, { path: '/', expires, maxAge: timeInSeconds });
            }
            this.props.validateUser();
        }
        else {
            let toastContent = {
                title: 'Notice',
                content: 'Invalid Code.'
            };
            this.toggleToast(toastContent);
        }
    }

    goLogin = () => {
        this.props.goLogin();
    }

    render() {

        return (



            <div className="slidePaneContent height100">
                <MyToast showToast={this.state.showToast} toggleToast={this.toggleToast} toastContent={this.state.toastContent} />
                <form id="login-form" className="" autoComplete="off">
                    <header>
                        Enter Code From Your Mobile Device
                    </header>
                    <fieldset>
                        <div className="form-group text-left">
                            <input type="hidden" value="" />
                            <div className="">
                                <label className="form-label">Enter the security code from the authenticator app on your mobile device</label>
                                <input autoFocus className="form-control" name="tfaInput" onChange={this.handleInputChange} value={this.state.formFields.tfaInput} />
                                <span className="help-block">
                                    6-digit code
                            </span>
                            </div>
                        </div>
                        <div className="form-group text-left">
                            <div className="custom-control custom-checkbox">
                                <input type="checkbox" className="custom-control-input" name="trustdevice" id="trustdevice" value={this.state.formFields.trustdevice} onChange={this.handleInputChange} />
                                <label className="custom-control-label" htmlFor="rememberme"> Trust this device. Security code will not be requested any more on this device.</label>
                            </div>
                        </div>
                    </fieldset>
                    <div className="row">
                        <div className="form-group col-12 text-right">
                            <button className="btn btn-default" onClick={(e) => { this.verify2FA(e); }}>Secure login</button>
                        </div>
                        <div className="form-group col-12 goBackLogin text-right">
                            <a onClick={this.goLogin}><i className="fa fa-arrow-left"></i> Go back to login</a>
                        </div>
                        <br />
                        {this.state.validUserFound === false &&
                            <div>
                                <span style={{ color: 'red' }}><h5>Invalid User Credentials</h5></span>
                            </div>
                        }
                    </div>
                </form>
            </div>
        );
    }
}
export default withRouter(TFALogin);